import { useEffect, useRef } from 'react';
import Image from '../../../../atoms/Image';
import closeIcon from '../../../../assets/images/close.svg';
import SidebarNavigation from './SidebarNavigation';
import SidebarFooter from './SidebarFooter';
import SidebarWallet from './SidebarWallet';

/**
 * Sidebar holder
 */
interface ISidebarProps {
  onBack(): void;
  onTrending(): void;
  onWatchlist(): void;
  onTrading(): void;
}

const Sidebar = (props: ISidebarProps) => {
  const { onBack, ...navigation } = props;

  const ref = useRef(null);

  const goBack = () => {
    if (ref.current) {
      (ref.current as HTMLElement).classList.remove(
        'global_sidebar_mobile--isVisible'
      );
    }
    setTimeout(() => {
      onBack();
    }, 300);
  };

  useEffect(() => {
    if (ref.current) {
      (ref.current as HTMLElement).classList.add(
        'global_sidebar_mobile--isVisible'
      );
    }
  }, []);

  return (
    <>
      <aside className='sidebar_background' />
      <div ref={ref} className='global_sidebar_mobile'>
        <SidebarNavigation {...navigation} />
        <SidebarWallet />
        <SidebarFooter />
        <div className='global_sidebar_mobile__close_icon'>
          <Image size='m' src={closeIcon} onClick={goBack} />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
